import React, { Component } from "react";
import Api from "Api/Api";
import Auth from "Api/Auth";
import Utils from "Utils";
import { navigate } from "@reach/router";

export default class OtpLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp: "",
      step: "email",
      loading: false,
      error: "",
    };
  }

  requestOtp = (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (!email) {
      this.setState({ error: "Please enter your email" });
      return;
    }

    this.setState({ loading: true, error: "" });

    Api.otpRequest(email).then((response) => {
      this.setState({ loading: false });

      if (response.status === 200) {
        this.setState({ step: "otp" });
        Utils.notify("OTP sent to your email", "success");
      } else if (response.status === 400) {
        const errorMsg =
          response.data?.user?.email?.[0] || "Invalid email address";
        this.setState({ error: errorMsg });
        Utils.notify(errorMsg, "error");
      } else {
        this.setState({ error: "Failed to request OTP. Please try again." });
        Utils.notify("Failed to request OTP", "error");
      }
    });
  };

  verifyOtp = (e) => {
    e.preventDefault();
    const { email, otp } = this.state;

    if (!otp) {
      this.setState({ error: "Please enter the OTP" });
      return;
    }

    this.setState({ loading: true, error: "" });

    Api.otpVerify(email, otp).then((response) => {
      this.setState({ loading: false });

      if (response.status === 200) {
        const token = response.data?.token || response.data?.access;
        if (token) {
          Auth.LoginUser(token);
          Utils.notify("Login successful", "success");
          navigate("/");
        } else {
          this.setState({ error: "No token received from server" });
          Utils.notify("Login failed: No token received", "error");
        }
      } else if (response.status === 400) {
        const errorMsg = response.data?.detail || "Invalid or expired OTP";
        this.setState({ error: errorMsg });
        Utils.notify(errorMsg, "error");
      } else {
        this.setState({ error: "Login failed. Please try again." });
        Utils.notify("Login failed", "error");
      }
    });
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value, error: "" });
  };

  handleOtpChange = (e) => {
    this.setState({ otp: e.target.value, error: "" });
  };

  backToEmail = () => {
    this.setState({ step: "email", otp: "", error: "" });
  };

  render() {
    const { email, otp, step, loading, error } = this.state;

    return (
      <div className="card card-login">
        {step === "email" ? (
          <form className="form" onSubmit={this.requestOtp}>
            <div className="card-body">
              <h4 className="card-title text-center mb-4">Login with OTP</h4>
              {error && <div className="alert alert-danger">{error}</div>}
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="material-icons">mail</i>
                  </span>
                </div>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={this.handleEmailChange}
                  required={true}
                />
              </div>
            </div>
            <div className="footer text-center login-btn">
              <button
                type="submit"
                className="btn btn-primary btn-wd btn-lg"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send OTP"}
              </button>
            </div>
          </form>
        ) : (
          <form className="form" onSubmit={this.verifyOtp}>
            <div className="card-body">
              <h4 className="card-title text-center mb-4">Enter OTP</h4>
              <p className="text-center text-muted mb-3">
                OTP has been sent to <strong>{email}</strong>
              </p>
              {error && <div className="alert alert-danger">{error}</div>}
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="material-icons">security</i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter 6-digit OTP"
                  value={otp}
                  onChange={this.handleOtpChange}
                  maxLength="6"
                  required={true}
                />
              </div>
              <div className="text-center mt-3">
                <p
                  onClick={this.backToEmail}
                  className="pointer"
                  style={{ color: "#a746b8", cursor: "pointer" }}
                >
                  Back to email
                </p>
              </div>
            </div>
            <div className="footer text-center login-btn">
              <button
                type="submit"
                className="btn btn-primary btn-wd btn-lg"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </div>
          </form>
        )}
      </div>
    );
  }
}
